import APIKit from "../Allapis/Apikit/apikit";

export const getShareClass = async (id) => {
  const endpoint = `/admin/products/list`;
  const res = await APIKit.get(endpoint, {
    params: { id: id },
  });
  console.log(res, "res in share class api");
  return res.data;
};

export const createShareClass = async (values) => {
  const res = await APIKit.post(`/admin/products`, values);
  return res.data;
};

export const updateShareClass = async (id, values) => {
  const res = await APIKit.put(`/admin/products/${id}`, values);
  return res.data;
};

export const deleteShareClass = async (id) => {
  console.log(id, "deleting id");
  const res = await APIKit.delete(`/admin/products/${id}`);
  console.log(res, "delete response");
  return res.data;
};
